import { getCurrentInstance } from "vue";
const useComponentUuid = () => {
  const vm = getCurrentInstance();
  return vm.uid + vm.appContext.app._uid;
};
export {
  useComponentUuid as u
};
//# sourceMappingURL=useComponentUuid-fe318ec5.mjs.map
